import { ProBadge } from '../../../../../core/licensing';

export function PersonalUpgradeSection() {
  return (
    <div
      className="rounded-md border border-border bg-muted/30 p-4"
      data-testid="pro-upgrade-section"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="space-y-1">
          <div className="flex items-center gap-2 text-sm font-medium">
            Multiple Sessions <ProBadge size="sm" />
          </div>
          <div className="text-xs text-muted-foreground">
            Upgrade to Pro to save and switch between multiple workspaces from Settings.
          </div>
        </div>
      </div>
    </div>
  );
}

